export enum UserJobTitle {
    EXTERNAL = 'external',
    MANAGER = 'manager',
    OWNER = 'owner',
    TEAM = 'team',
}
